import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './plugins/faker'
import i18n from './i18n'
import './plugins/zendesk'
import moment from 'moment'
import Vue2Filters from 'vue2-filters'
import VueBlobJsonCsv from 'vue-blob-json-csv'

Vue.config.productionTip = false

i18n.locale = store.state.app.locale
moment.locale(store.state.app.locale)
Vue.use(require('vue-moment'), { moment })

Vue.use(Vue2Filters)
Vue.use(VueBlobJsonCsv)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  mixins: [Vue2Filters.mixin],
  render: h => h(App),
}).$mount('#app')
